<template>
<div>
  <vue-headful
    :title=productCategory.description
    :description=productCategory.text
    :keywords=productCategory.keywords
  />
  <top-navigation></top-navigation>
  <div>
    <div class="container">
      <div class="row">
        <left-sidebar :showProductCategoryNavigation=true></left-sidebar>
        <div class="col-sm-9 padding-right product-information">
            <h2>{{ productCategory.description }}</h2>
            <p>{{ productCategory.text}}</p>
            <p>&nbsp;</p>
            <p><a target="_new" :href="eBayUrl" class="btn btn-default">Visit our eBay Shop</a></p>
            <p>&nbsp;</p>
            <div class="horizontal-scrolling-area" v-if="productCategory.products.length">
              <table class="table table-responsive table-striped">
                <thead>
                  <tr>
                    <td>Title</td>
                    <td>Description</td>
                    <td>Price</td>
                  </tr>
                </thead>
                <tbody>
                    <template v-for="product in productCategory.products">
                      <books :product="product" v-bind:key="product.id"></books>
                    </template>
                </tbody>
              </table>
            </div>
            <div v-else>
              <b>Please visit our eBay Shop for our current stock.</b>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import LeftSidebar from '../../components/common/LeftSidebar';
import ProductCategories from '../../components/products/ProductCategories';
import TopNavigation from '../../components/common/TopNavigation';
import Books from './books';
import { EBAY_SHOP_URL } from '../../config';

export default {
  name: 'product-category-page',
  created() {
    if (this.productCategory.length === 0 || this.currentPage !== this.$route.params.categorySlug) {
      this.$store.dispatch('productById', this.slug);
    }
  },
  computed: {
    productCategory() {
      const unsortedProducts = this.$store.getters.productById(this.$route.params.categorySlug);
      return unsortedProducts;
    },
    currentPage() {
      return this.$store.getters.getCurrentPage;
    },
  },
  data() {
    return {
      slug: this.$route.params.categorySlug,
      eBayUrl: EBAY_SHOP_URL,
    };
  },
  watch: {
    /* eslint no-unused-vars: [2, { "args": "none" }] */
    $route(to, from) {
      if (this.currentPage !== this.$route.params.categorySlug) {
        this.$store.dispatch('productById', this.$route.params.categorySlug);
        this.wisdenyear = '';
        this.bookletter = '';
      }
    },
  },
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
    'product-categories': ProductCategories,
    books: Books,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/selling/Category.vue